/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Vu Dinh Luan (vdluan@rsupport.com)
 *
 * @description
 *
 * @created at Fri Sep 13 2024
 **/

import { Button, Row, Typography, useModal } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";
import { ModalID, SidebarID } from "@/frameworks/core/commons";
import { useConfirm, useCreateWorkGroup, useSidebarActions } from "@/frameworks/core/hooks";

import DescriptionField from "./components/DescriptionField";
import * as S from "./emotion";
import { ImageField, KeywordField, NameField, SearchAllowTypeField, SearchSettingField } from "./components";
import CreateGroupLayout from "../CreateGroupLayout";

export default function CreateGroupForNewMember() {
	const {
		name,
		handlers: { handleResetAll, handleCreateWorkGroup, getState }
	} = useCreateWorkGroup();

	const sidebarActions = useSidebarActions();
	const { hide } = useModal();
	const { confirm } = useConfirm();

	const hideModalSidebar = () => {
		hide(ModalID.CREATE_GROUP_FOR_NEW_MEMBER);
		sidebarActions.hide(SidebarID.Meeting);
		sidebarActions.show(SidebarID.Space);
	};

	const handleClick = () => {
		handleCreateWorkGroup();
		hideModalSidebar();
	};

	const handleCloseCreateWorkGroup = () => {
		if (!isCreateGroupWritingCheck()) {
			hideModalSidebar();
			handleResetAll();
		} else {
			confirm(_T("작성중인 데이터가 있습니다. 그래도 닫으시겠습니까?"), {
				onConfirm() {
					hideModalSidebar();
					handleResetAll();
				}
			});
		}
	};

	const isCreateGroupWritingCheck = () => {
		return Boolean(
			getState().CreateWorkGroupName ||
				getState().CreateWorkGroupKeywords.length > 0 ||
				getState().CreateWorkGroupDescription
		);
	};

	return (
		<CreateGroupLayout handleClose={handleCloseCreateWorkGroup}>
			<Typography
				css={{
					fontWeight: "800",
					fontSize: "64px",
					marginBottom: "32px",
					lineHeight: "76px"
				}}
				typoColor="neutral_80_100"
			>
				{_T("그룹 만들기")}
			</Typography>
			<Row>
				<S.Content gap={20}>
					<ImageField />
					<NameField />
					<DescriptionField />
					<KeywordField />
				</S.Content>
				<S.Content css={{ marginTop: 120 }} gap={20}>
					<SearchAllowTypeField />
					<SearchSettingField />
				</S.Content>
			</Row>
			<S.FooterContent verticalAlign="center" horizonAlign="right" gap={18}>
				<Button
					css={{ width: 160, height: 44, borderRadius: 32 }}
					onClick={handleCloseCreateWorkGroup}
					filled="secondary"
					size="large"
				>
					{_T("취소")}
				</Button>
				<Button
					css={{ width: 160, height: 44, borderRadius: 32 }}
					onClick={handleClick}
					disabled={Boolean(!name)}
					size="large"
				>
					{_T("만들기")}
				</Button>
			</S.FooterContent>
		</CreateGroupLayout>
	);
}
